import * as types from 'store/mutation-types'

// initial state
const state = {
	orderStatus: 0
}

// actions
const actions = {
  //订单刷新状态
  setorderstatus ({ commit}) {
    commit(types.SET_ORDER_STATUS)
  }
}

// mutations
const mutations = {
  //设备报警类型
  [types.SET_ORDER_STATUS] (state) {
  		state.orderStatus+=1
  }
}


export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js